/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as AuthRouteRouteImport } from './../routes/auth/route'
import { Route as ProtectedRouteRouteImport } from './../routes/_protected/route'
import { Route as IndexRouteImport } from './../routes/index'
import { Route as AuthSuccessRouteImport } from './../routes/auth/success'
import { Route as AuthLogoutRouteImport } from './../routes/auth/logout'
import { Route as AuthLoginRouteImport } from './../routes/auth/login'
import { Route as AuthErrorRouteImport } from './../routes/auth/error'
import { Route as AuthCallbackRouteImport } from './../routes/auth/callback'
import { Route as ProtectedSettingsRouteImport } from './../routes/_protected/settings'
import { Route as ProtectedProfileRouteImport } from './../routes/_protected/profile'
import { Route as ProtectedIntakeRouteImport } from './../routes/_protected/intake'
import { Route as ProtectedAssessmentRouteImport } from './../routes/_protected/assessment'
import { Route as ProtectedDashboardIndexRouteImport } from './../routes/_protected/dashboard.index'
import { Route as ProtectedCasesIndexRouteImport } from './../routes/_protected/cases.index'
import { Route as ProtectedActionItemsIndexRouteImport } from './../routes/_protected/action-items.index'
import { Route as ProtectedSettingsIntegrationRoutesRouteImport } from './../routes/_protected/settings_.integration-routes'
import { Route as ProtectedSettingsIntegrationKeysRouteImport } from './../routes/_protected/settings_.integration-keys'
import { Route as ProtectedSettingsFeatureTogglesRouteImport } from './../routes/_protected/settings_.feature-toggles'
import { Route as ProtectedDashboardUsersRouteImport } from './../routes/_protected/dashboard.users'
import { Route as ProtectedDashboardPoliciesAndDocumentsRouteImport } from './../routes/_protected/dashboard.policies-and-documents'
import { Route as ProtectedDashboardIntegrationsRouteImport } from './../routes/_protected/dashboard.integrations'
import { Route as ProtectedDashboardCompanyHubRouteImport } from './../routes/_protected/dashboard.company-hub'
import { Route as ProtectedDashboardCompanyDetailsRouteImport } from './../routes/_protected/dashboard.company-details'
import { Route as ProtectedDashboardCreateClientSlugRouteImport } from './../routes/_protected/dashboard.$createClientSlug'
import { Route as ProtectedCasesCaseIdRouteImport } from './../routes/_protected/cases.$caseId'
import { Route as ProtectedCasesVersion2CaseIdRouteImport } from './../routes/_protected/cases-version-2.$caseId'
import { Route as ProtectedAriesConfirmationRouteImport } from './../routes/_protected/aries/confirmation'
import { Route as ProtectedActionItemsViewRouteImport } from './../routes/_protected/action-items.$view'
import { Route as ProtectedDashboardEmployeesIndexRouteImport } from './../routes/_protected/dashboard.employees.index'

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRouteRoute = ProtectedRouteRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSuccessRoute = AuthSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AuthRouteRoute,
} as any)
const ProtectedSettingsRoute = ProtectedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedProfileRoute = ProtectedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedIntakeRoute = ProtectedIntakeRouteImport.update({
  id: '/intake',
  path: '/intake',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedAssessmentRoute = ProtectedAssessmentRouteImport.update({
  id: '/assessment',
  path: '/assessment',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedDashboardIndexRoute = ProtectedDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedCasesIndexRoute = ProtectedCasesIndexRouteImport.update({
  id: '/cases/',
  path: '/cases/',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedActionItemsIndexRoute =
  ProtectedActionItemsIndexRouteImport.update({
    id: '/action-items/',
    path: '/action-items/',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedSettingsIntegrationRoutesRoute =
  ProtectedSettingsIntegrationRoutesRouteImport.update({
    id: '/settings_/integration-routes',
    path: '/settings/integration-routes',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedSettingsIntegrationKeysRoute =
  ProtectedSettingsIntegrationKeysRouteImport.update({
    id: '/settings_/integration-keys',
    path: '/settings/integration-keys',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedSettingsFeatureTogglesRoute =
  ProtectedSettingsFeatureTogglesRouteImport.update({
    id: '/settings_/feature-toggles',
    path: '/settings/feature-toggles',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedDashboardUsersRoute = ProtectedDashboardUsersRouteImport.update({
  id: '/dashboard/users',
  path: '/dashboard/users',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedDashboardPoliciesAndDocumentsRoute =
  ProtectedDashboardPoliciesAndDocumentsRouteImport.update({
    id: '/dashboard/policies-and-documents',
    path: '/dashboard/policies-and-documents',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedDashboardIntegrationsRoute =
  ProtectedDashboardIntegrationsRouteImport.update({
    id: '/dashboard/integrations',
    path: '/dashboard/integrations',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedDashboardCompanyHubRoute =
  ProtectedDashboardCompanyHubRouteImport.update({
    id: '/dashboard/company-hub',
    path: '/dashboard/company-hub',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedDashboardCompanyDetailsRoute =
  ProtectedDashboardCompanyDetailsRouteImport.update({
    id: '/dashboard/company-details',
    path: '/dashboard/company-details',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedDashboardCreateClientSlugRoute =
  ProtectedDashboardCreateClientSlugRouteImport.update({
    id: '/dashboard/$createClientSlug',
    path: '/dashboard/$createClientSlug',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedCasesCaseIdRoute = ProtectedCasesCaseIdRouteImport.update({
  id: '/cases/$caseId',
  path: '/cases/$caseId',
  getParentRoute: () => ProtectedRouteRoute,
} as any)
const ProtectedCasesVersion2CaseIdRoute =
  ProtectedCasesVersion2CaseIdRouteImport.update({
    id: '/cases-version-2/$caseId',
    path: '/cases-version-2/$caseId',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedAriesConfirmationRoute =
  ProtectedAriesConfirmationRouteImport.update({
    id: '/aries/confirmation',
    path: '/aries/confirmation',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedActionItemsViewRoute =
  ProtectedActionItemsViewRouteImport.update({
    id: '/action-items/$view',
    path: '/action-items/$view',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)
const ProtectedDashboardEmployeesIndexRoute =
  ProtectedDashboardEmployeesIndexRouteImport.update({
    id: '/dashboard/employees/',
    path: '/dashboard/employees/',
    getParentRoute: () => ProtectedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/assessment': typeof ProtectedAssessmentRoute
  '/intake': typeof ProtectedIntakeRoute
  '/profile': typeof ProtectedProfileRoute
  '/settings': typeof ProtectedSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/success': typeof AuthSuccessRoute
  '/action-items/$view': typeof ProtectedActionItemsViewRoute
  '/aries/confirmation': typeof ProtectedAriesConfirmationRoute
  '/cases-version-2/$caseId': typeof ProtectedCasesVersion2CaseIdRoute
  '/cases/$caseId': typeof ProtectedCasesCaseIdRoute
  '/dashboard/$createClientSlug': typeof ProtectedDashboardCreateClientSlugRoute
  '/dashboard/company-details': typeof ProtectedDashboardCompanyDetailsRoute
  '/dashboard/company-hub': typeof ProtectedDashboardCompanyHubRoute
  '/dashboard/integrations': typeof ProtectedDashboardIntegrationsRoute
  '/dashboard/policies-and-documents': typeof ProtectedDashboardPoliciesAndDocumentsRoute
  '/dashboard/users': typeof ProtectedDashboardUsersRoute
  '/settings/feature-toggles': typeof ProtectedSettingsFeatureTogglesRoute
  '/settings/integration-keys': typeof ProtectedSettingsIntegrationKeysRoute
  '/settings/integration-routes': typeof ProtectedSettingsIntegrationRoutesRoute
  '/action-items/': typeof ProtectedActionItemsIndexRoute
  '/cases/': typeof ProtectedCasesIndexRoute
  '/dashboard/': typeof ProtectedDashboardIndexRoute
  '/dashboard/employees/': typeof ProtectedDashboardEmployeesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/assessment': typeof ProtectedAssessmentRoute
  '/intake': typeof ProtectedIntakeRoute
  '/profile': typeof ProtectedProfileRoute
  '/settings': typeof ProtectedSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/success': typeof AuthSuccessRoute
  '/action-items/$view': typeof ProtectedActionItemsViewRoute
  '/aries/confirmation': typeof ProtectedAriesConfirmationRoute
  '/cases-version-2/$caseId': typeof ProtectedCasesVersion2CaseIdRoute
  '/cases/$caseId': typeof ProtectedCasesCaseIdRoute
  '/dashboard/$createClientSlug': typeof ProtectedDashboardCreateClientSlugRoute
  '/dashboard/company-details': typeof ProtectedDashboardCompanyDetailsRoute
  '/dashboard/company-hub': typeof ProtectedDashboardCompanyHubRoute
  '/dashboard/integrations': typeof ProtectedDashboardIntegrationsRoute
  '/dashboard/policies-and-documents': typeof ProtectedDashboardPoliciesAndDocumentsRoute
  '/dashboard/users': typeof ProtectedDashboardUsersRoute
  '/settings/feature-toggles': typeof ProtectedSettingsFeatureTogglesRoute
  '/settings/integration-keys': typeof ProtectedSettingsIntegrationKeysRoute
  '/settings/integration-routes': typeof ProtectedSettingsIntegrationRoutesRoute
  '/action-items': typeof ProtectedActionItemsIndexRoute
  '/cases': typeof ProtectedCasesIndexRoute
  '/dashboard': typeof ProtectedDashboardIndexRoute
  '/dashboard/employees': typeof ProtectedDashboardEmployeesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/_protected/assessment': typeof ProtectedAssessmentRoute
  '/_protected/intake': typeof ProtectedIntakeRoute
  '/_protected/profile': typeof ProtectedProfileRoute
  '/_protected/settings': typeof ProtectedSettingsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/error': typeof AuthErrorRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/logout': typeof AuthLogoutRoute
  '/auth/success': typeof AuthSuccessRoute
  '/_protected/action-items/$view': typeof ProtectedActionItemsViewRoute
  '/_protected/aries/confirmation': typeof ProtectedAriesConfirmationRoute
  '/_protected/cases-version-2/$caseId': typeof ProtectedCasesVersion2CaseIdRoute
  '/_protected/cases/$caseId': typeof ProtectedCasesCaseIdRoute
  '/_protected/dashboard/$createClientSlug': typeof ProtectedDashboardCreateClientSlugRoute
  '/_protected/dashboard/company-details': typeof ProtectedDashboardCompanyDetailsRoute
  '/_protected/dashboard/company-hub': typeof ProtectedDashboardCompanyHubRoute
  '/_protected/dashboard/integrations': typeof ProtectedDashboardIntegrationsRoute
  '/_protected/dashboard/policies-and-documents': typeof ProtectedDashboardPoliciesAndDocumentsRoute
  '/_protected/dashboard/users': typeof ProtectedDashboardUsersRoute
  '/_protected/settings_/feature-toggles': typeof ProtectedSettingsFeatureTogglesRoute
  '/_protected/settings_/integration-keys': typeof ProtectedSettingsIntegrationKeysRoute
  '/_protected/settings_/integration-routes': typeof ProtectedSettingsIntegrationRoutesRoute
  '/_protected/action-items/': typeof ProtectedActionItemsIndexRoute
  '/_protected/cases/': typeof ProtectedCasesIndexRoute
  '/_protected/dashboard/': typeof ProtectedDashboardIndexRoute
  '/_protected/dashboard/employees/': typeof ProtectedDashboardEmployeesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/assessment'
    | '/intake'
    | '/profile'
    | '/settings'
    | '/auth/callback'
    | '/auth/error'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/success'
    | '/action-items/$view'
    | '/aries/confirmation'
    | '/cases-version-2/$caseId'
    | '/cases/$caseId'
    | '/dashboard/$createClientSlug'
    | '/dashboard/company-details'
    | '/dashboard/company-hub'
    | '/dashboard/integrations'
    | '/dashboard/policies-and-documents'
    | '/dashboard/users'
    | '/settings/feature-toggles'
    | '/settings/integration-keys'
    | '/settings/integration-routes'
    | '/action-items/'
    | '/cases/'
    | '/dashboard/'
    | '/dashboard/employees/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/assessment'
    | '/intake'
    | '/profile'
    | '/settings'
    | '/auth/callback'
    | '/auth/error'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/success'
    | '/action-items/$view'
    | '/aries/confirmation'
    | '/cases-version-2/$caseId'
    | '/cases/$caseId'
    | '/dashboard/$createClientSlug'
    | '/dashboard/company-details'
    | '/dashboard/company-hub'
    | '/dashboard/integrations'
    | '/dashboard/policies-and-documents'
    | '/dashboard/users'
    | '/settings/feature-toggles'
    | '/settings/integration-keys'
    | '/settings/integration-routes'
    | '/action-items'
    | '/cases'
    | '/dashboard'
    | '/dashboard/employees'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/auth'
    | '/_protected/assessment'
    | '/_protected/intake'
    | '/_protected/profile'
    | '/_protected/settings'
    | '/auth/callback'
    | '/auth/error'
    | '/auth/login'
    | '/auth/logout'
    | '/auth/success'
    | '/_protected/action-items/$view'
    | '/_protected/aries/confirmation'
    | '/_protected/cases-version-2/$caseId'
    | '/_protected/cases/$caseId'
    | '/_protected/dashboard/$createClientSlug'
    | '/_protected/dashboard/company-details'
    | '/_protected/dashboard/company-hub'
    | '/_protected/dashboard/integrations'
    | '/_protected/dashboard/policies-and-documents'
    | '/_protected/dashboard/users'
    | '/_protected/settings_/feature-toggles'
    | '/_protected/settings_/integration-keys'
    | '/_protected/settings_/integration-routes'
    | '/_protected/action-items/'
    | '/_protected/cases/'
    | '/_protected/dashboard/'
    | '/_protected/dashboard/employees/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRouteRoute: typeof ProtectedRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/success': {
      id: '/auth/success'
      path: '/success'
      fullPath: '/auth/success'
      preLoaderRoute: typeof AuthSuccessRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/error': {
      id: '/auth/error'
      path: '/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_protected/settings': {
      id: '/_protected/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof ProtectedSettingsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/profile': {
      id: '/_protected/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProtectedProfileRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/intake': {
      id: '/_protected/intake'
      path: '/intake'
      fullPath: '/intake'
      preLoaderRoute: typeof ProtectedIntakeRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/assessment': {
      id: '/_protected/assessment'
      path: '/assessment'
      fullPath: '/assessment'
      preLoaderRoute: typeof ProtectedAssessmentRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/dashboard/': {
      id: '/_protected/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof ProtectedDashboardIndexRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/cases/': {
      id: '/_protected/cases/'
      path: '/cases'
      fullPath: '/cases/'
      preLoaderRoute: typeof ProtectedCasesIndexRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/action-items/': {
      id: '/_protected/action-items/'
      path: '/action-items'
      fullPath: '/action-items/'
      preLoaderRoute: typeof ProtectedActionItemsIndexRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/settings_/integration-routes': {
      id: '/_protected/settings_/integration-routes'
      path: '/settings/integration-routes'
      fullPath: '/settings/integration-routes'
      preLoaderRoute: typeof ProtectedSettingsIntegrationRoutesRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/settings_/integration-keys': {
      id: '/_protected/settings_/integration-keys'
      path: '/settings/integration-keys'
      fullPath: '/settings/integration-keys'
      preLoaderRoute: typeof ProtectedSettingsIntegrationKeysRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/settings_/feature-toggles': {
      id: '/_protected/settings_/feature-toggles'
      path: '/settings/feature-toggles'
      fullPath: '/settings/feature-toggles'
      preLoaderRoute: typeof ProtectedSettingsFeatureTogglesRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/dashboard/users': {
      id: '/_protected/dashboard/users'
      path: '/dashboard/users'
      fullPath: '/dashboard/users'
      preLoaderRoute: typeof ProtectedDashboardUsersRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/dashboard/policies-and-documents': {
      id: '/_protected/dashboard/policies-and-documents'
      path: '/dashboard/policies-and-documents'
      fullPath: '/dashboard/policies-and-documents'
      preLoaderRoute: typeof ProtectedDashboardPoliciesAndDocumentsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/dashboard/integrations': {
      id: '/_protected/dashboard/integrations'
      path: '/dashboard/integrations'
      fullPath: '/dashboard/integrations'
      preLoaderRoute: typeof ProtectedDashboardIntegrationsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/dashboard/company-hub': {
      id: '/_protected/dashboard/company-hub'
      path: '/dashboard/company-hub'
      fullPath: '/dashboard/company-hub'
      preLoaderRoute: typeof ProtectedDashboardCompanyHubRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/dashboard/company-details': {
      id: '/_protected/dashboard/company-details'
      path: '/dashboard/company-details'
      fullPath: '/dashboard/company-details'
      preLoaderRoute: typeof ProtectedDashboardCompanyDetailsRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/dashboard/$createClientSlug': {
      id: '/_protected/dashboard/$createClientSlug'
      path: '/dashboard/$createClientSlug'
      fullPath: '/dashboard/$createClientSlug'
      preLoaderRoute: typeof ProtectedDashboardCreateClientSlugRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/cases/$caseId': {
      id: '/_protected/cases/$caseId'
      path: '/cases/$caseId'
      fullPath: '/cases/$caseId'
      preLoaderRoute: typeof ProtectedCasesCaseIdRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/cases-version-2/$caseId': {
      id: '/_protected/cases-version-2/$caseId'
      path: '/cases-version-2/$caseId'
      fullPath: '/cases-version-2/$caseId'
      preLoaderRoute: typeof ProtectedCasesVersion2CaseIdRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/aries/confirmation': {
      id: '/_protected/aries/confirmation'
      path: '/aries/confirmation'
      fullPath: '/aries/confirmation'
      preLoaderRoute: typeof ProtectedAriesConfirmationRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/action-items/$view': {
      id: '/_protected/action-items/$view'
      path: '/action-items/$view'
      fullPath: '/action-items/$view'
      preLoaderRoute: typeof ProtectedActionItemsViewRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
    '/_protected/dashboard/employees/': {
      id: '/_protected/dashboard/employees/'
      path: '/dashboard/employees'
      fullPath: '/dashboard/employees/'
      preLoaderRoute: typeof ProtectedDashboardEmployeesIndexRouteImport
      parentRoute: typeof ProtectedRouteRoute
    }
  }
}

interface ProtectedRouteRouteChildren {
  ProtectedAssessmentRoute: typeof ProtectedAssessmentRoute
  ProtectedIntakeRoute: typeof ProtectedIntakeRoute
  ProtectedProfileRoute: typeof ProtectedProfileRoute
  ProtectedSettingsRoute: typeof ProtectedSettingsRoute
  ProtectedActionItemsViewRoute: typeof ProtectedActionItemsViewRoute
  ProtectedAriesConfirmationRoute: typeof ProtectedAriesConfirmationRoute
  ProtectedCasesVersion2CaseIdRoute: typeof ProtectedCasesVersion2CaseIdRoute
  ProtectedCasesCaseIdRoute: typeof ProtectedCasesCaseIdRoute
  ProtectedDashboardCreateClientSlugRoute: typeof ProtectedDashboardCreateClientSlugRoute
  ProtectedDashboardCompanyDetailsRoute: typeof ProtectedDashboardCompanyDetailsRoute
  ProtectedDashboardCompanyHubRoute: typeof ProtectedDashboardCompanyHubRoute
  ProtectedDashboardIntegrationsRoute: typeof ProtectedDashboardIntegrationsRoute
  ProtectedDashboardPoliciesAndDocumentsRoute: typeof ProtectedDashboardPoliciesAndDocumentsRoute
  ProtectedDashboardUsersRoute: typeof ProtectedDashboardUsersRoute
  ProtectedSettingsFeatureTogglesRoute: typeof ProtectedSettingsFeatureTogglesRoute
  ProtectedSettingsIntegrationKeysRoute: typeof ProtectedSettingsIntegrationKeysRoute
  ProtectedSettingsIntegrationRoutesRoute: typeof ProtectedSettingsIntegrationRoutesRoute
  ProtectedActionItemsIndexRoute: typeof ProtectedActionItemsIndexRoute
  ProtectedCasesIndexRoute: typeof ProtectedCasesIndexRoute
  ProtectedDashboardIndexRoute: typeof ProtectedDashboardIndexRoute
  ProtectedDashboardEmployeesIndexRoute: typeof ProtectedDashboardEmployeesIndexRoute
}

const ProtectedRouteRouteChildren: ProtectedRouteRouteChildren = {
  ProtectedAssessmentRoute: ProtectedAssessmentRoute,
  ProtectedIntakeRoute: ProtectedIntakeRoute,
  ProtectedProfileRoute: ProtectedProfileRoute,
  ProtectedSettingsRoute: ProtectedSettingsRoute,
  ProtectedActionItemsViewRoute: ProtectedActionItemsViewRoute,
  ProtectedAriesConfirmationRoute: ProtectedAriesConfirmationRoute,
  ProtectedCasesVersion2CaseIdRoute: ProtectedCasesVersion2CaseIdRoute,
  ProtectedCasesCaseIdRoute: ProtectedCasesCaseIdRoute,
  ProtectedDashboardCreateClientSlugRoute:
    ProtectedDashboardCreateClientSlugRoute,
  ProtectedDashboardCompanyDetailsRoute: ProtectedDashboardCompanyDetailsRoute,
  ProtectedDashboardCompanyHubRoute: ProtectedDashboardCompanyHubRoute,
  ProtectedDashboardIntegrationsRoute: ProtectedDashboardIntegrationsRoute,
  ProtectedDashboardPoliciesAndDocumentsRoute:
    ProtectedDashboardPoliciesAndDocumentsRoute,
  ProtectedDashboardUsersRoute: ProtectedDashboardUsersRoute,
  ProtectedSettingsFeatureTogglesRoute: ProtectedSettingsFeatureTogglesRoute,
  ProtectedSettingsIntegrationKeysRoute: ProtectedSettingsIntegrationKeysRoute,
  ProtectedSettingsIntegrationRoutesRoute:
    ProtectedSettingsIntegrationRoutesRoute,
  ProtectedActionItemsIndexRoute: ProtectedActionItemsIndexRoute,
  ProtectedCasesIndexRoute: ProtectedCasesIndexRoute,
  ProtectedDashboardIndexRoute: ProtectedDashboardIndexRoute,
  ProtectedDashboardEmployeesIndexRoute: ProtectedDashboardEmployeesIndexRoute,
}

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(
  ProtectedRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthErrorRoute: typeof AuthErrorRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  AuthSuccessRoute: typeof AuthSuccessRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthCallbackRoute: AuthCallbackRoute,
  AuthErrorRoute: AuthErrorRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  AuthSuccessRoute: AuthSuccessRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
